import React, { useState, useEffect } from "react";
import { Col, Form, Input, Button, Table, Select } from "antd";

const Clients = () => {
  const [selected, setSelected] = useState(null);
  const [form] = Form.useForm();
  const [data, setData] = useState([
    {
      name: "Cliente1",
      dni: "11.111.111-1",
      address: "Direccion1",
      phone: "+56 9 1234 5678",
      email: "contact@dominio.cl",
    },
    {
      name: "Cliente2",
      dni: "11.111.111-2",
      address: "Direccion1",
      phone: "+56 9 1234 5678",
      email: "contact@dominio.cl",
    },
    {
      name: "Cliente3",
      dni: "11.111.111-3",
      address: "Direccion1",
      phone: "+56 9 1234 5678",
      email: "contact@dominio.cl",
    },
    {
      name: "Cliente4",
      dni: "11.111.111-4",
      address: "Direccion1",
      phone: "+56 9 1234 5678",
      email: "contact@dominio.cl",
    },
  ]);
  useEffect(() => {
    if (selected) {
      form.setFieldValue("name", selected.name);
      form.setFieldValue("dni", selected.dni);
      form.setFieldValue("address", selected.address);
      form.setFieldValue("phone", selected.phone);
      form.setFieldValue("email", selected.email);
    }
  }, [selected]);
  console.log(selected);
  return (
    <>
      <Col span={16} style={{ padding: "30px" }}>
        <Table
          dataSource={data}
          expandable={{
            expandedRowRender: (record) => (
              <>
                <p style={{ margin: 0 }}>Direccion:{record.address}</p>
                <p style={{ margin: 0 }}>Telefono:{record.phone}</p>
                <p style={{ margin: 0 }}>Email:{record.email}</p>
              </>
            ),
          }}
          columns={[
            { title: "Nombre", dataIndex: "name" },
            { title: "Rut", dataIndex: "dni" },
            {
              render: (x) => (
                <>
                  <Button style={{ marginRight: "10px" }} type="primary" danger>
                    Eliminar
                  </Button>
                  <Button type="primary" onClick={() => setSelected(x)}>
                    Editor
                  </Button>
                </>
              ),
            },
          ]}
        />
      </Col>
      <Col span={8} style={{ padding: "30px" }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={(values) => {
            if (selected) {
            } else {
              setData([...data, values]);
            }
          }}
          initialValues={selected}
        >
          <Form.Item label="Nombre" name="name">
            <Input />
          </Form.Item>
          <Form.Item label="Rut" name="dni">
            <Input />
          </Form.Item>
          <Form.Item label="Direccion" name="address">
            <Input />
          </Form.Item>
          <Form.Item label="Telefono" name="phone">
            <Input />
          </Form.Item>
          <Form.Item label="Email" name="email">
            <Input />
          </Form.Item>

          <Form.Item>
            <Button
              htmlType="submit"
              type="primary"
              style={{ marginRight: "10px" }}
            >
              Crear
            </Button>
            <Button onClick={() => form.resetFields()}>Limpiar</Button>
          </Form.Item>
        </Form>
      </Col>
    </>
  );
};

export default Clients;
